<template>
  <div class="card accordion">
    <div class="card-body">
      <div class="card-title">
        <h2>
          사용자 생성
        </h2>
        <p class="text-light-gray">사용자를 추가하세요.</p>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="140px" class="demo-form">
      <div :class="stepClassName(0)" id="first-step">
        <div class="arrow-down"><i class="fas fa-sort-down"></i></div>
        <h5><span class="number circle">1</span> 사용자 구분</h5>
        <div class="card-form accordion-item-body" v-if="step[0]">

          <div class="text-center">
            <h6>어떤 사용자를 추가하시겠어요?</h6>
            <p class="small text-gray description">선택한 사용자 <span class="text-light-blue" id="selected_user_type">{{userTypeName}}</span></p>

            <!-- <label>
              <div class="user-type student"></div>
              <h3>학생</h3>
              <input type="radio" v-model="frm.user_type" value="S" />
            </label> -->
            <label>
              <div class="user-type tutor"></div>
              <h3>선생님</h3>
              <input type="radio" v-model="frm.user_type" value="T" />
            </label>
            <label>
              <div class="user-type admin"></div>
              <h3>관리자</h3>
              <input type="radio" v-model="frm.user_type" value="A" />
            </label>
          </div>

          <div class="text-right">
            <el-button type="primary" @click="stepHandler(1)">다음</el-button>
          </div>
        </div>
      </div>

      <div :class="stepClassName(1)" id="second-step">
        <div class="arrow-down"><i class="fas fa-sort-down"></i></div>
        <h5><span class="number circle">2</span> 사용자 정보 입력</h5>
        <div class="card-form accordion-item-body" v-if="step[1]">
          <el-form-item label="사진" prop="">
            <div class="mr-3">
              <p class="small description">기본정보를 입력해 주세요.</p>
              <el-upload class="avatar-uploader" action="/api/file/upload"
                :headers="fileHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="아이디" prop="id">
            <el-input v-model="userId" :disabled="frm.user_type === 'S'" placeholder="아이디" :maxlength="15"></el-input>
          </el-form-item>
          <el-form-item label="이름" prop="name">
            <el-input v-model.trim="frm.name" placeholder="이름" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="생년월일" required>
            <el-col :span="8">
              <el-form-item prop="birthday_yyyy">
                <el-select v-model="frm.birthday_yyyy" placeholder="년" >
                  <el-option v-for="y in yearCount" :key="y" :label="`${y + startYear} 년`" :value="y + startYear">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="birthday_mm">
                <el-select v-model="frm.birthday_mm" placeholder="월">
                  <el-option v-for="m in 12" :key="m" :label="`${m} 월`" :value="getDateValue(m)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="birthday_dd">
                <el-select v-model="frm.birthday_dd" placeholder="일">
                  <el-option v-for="d in getDays" :key="d" :label="`${d} 일`" :value="getDateValue(d)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="전화번호" prop="phone">
            <el-input v-model.trim="frm.phone" placeholder="'-' 를 빼고 입력하십시오" @change="autoHypenPhone('phone')" :maxlength="13"></el-input>
          </el-form-item>
          <el-form-item label="보호자 전화번호" prop="parent_phone" v-if="frm.user_type === 'S'">
            <el-input v-model.trim="frm.parent_phone" placeholder="'-' 를 빼고 입력하십시오" @change="autoHypenPhone('parent_phone')" :maxlength="13"></el-input>
          </el-form-item>
          <el-form-item label="학교" prop="school_name" v-if="frm.user_type === 'S'">
            <el-input v-model.trim="frm.school_name"></el-input>
          </el-form-item>
        </div>

        <div class="card-body text-right" v-if="step[1]">
          <el-button class="white" @click="stepFirst">이전</el-button>
          <el-button type="primary" @click="validationForm('frm')">다음</el-button>
        </div>
      </div>

      <div :class="stepClassName(2)" id="third-step">
        <div class="arrow-down"><i class="fas fa-sort-down"></i></div>
        <h5><span class="number circle">3</span> 확인</h5>
        <!-- <p class="small description">기본정보를 입력해 주세요.</p> -->
        <div class="card-form accordion-item-body" v-if="step[2]">
          <div class="text-center">
            <h6>사용자를 추가하시겠습니까?</h6>
            <p class="small text-gray description">사용자의 기본 비밀번호는 휴대폰 뒷자리 <span class="text-light-blue" id="default-password">{{userPassword}}</span> 입니다.</p>
          </div>
          <div class="add-usercard">
            <div class="media">
              <template v-if="imageUrl !== ''">
                <b-img  alt="img" class="m-1" :src="imageUrl" />
              </template>
              <template v-else>
                <b-img  alt="img" class="m-1" src="/static/img/user@3x.png" />
              </template>
              <div class="media-body">
                <h6>{{frm.name}}</h6>
                <p class="number small">{{`${frm.birthday_yyyy}-${frm.birthday_mm}-${frm.birthday_dd}`}}</p>
              </div>
            </div>
            <dl>
              <dt>전화번호</dt>
              <dd class="number">{{frm.phone}}</dd>
            </dl>
            <dl v-if="frm.user_type === 'S'">
              <dt>보호자 전화번호</dt>
              <dd class="number">{{frm.parent_phone}}</dd>
            </dl>
          </div>
        </div>
        <div class="card-body text-right" v-if="step[2]">
          <el-button @click="stepFirst">취소</el-button>
          <el-button type="primary" @click="submitForm('frm')">저장</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990202',
  mixins: [common.mixins],
  data () {
    const checkUserId = (rule, value, callback) => {
      common.axios.post('/user/check', {id: this.frm.id})
        .then(response => {
          if (response.data.status === 1) {
            callback()
          } else {
            callback(new Error(response.data.message))
          }
        })
    }
    return {
      isUse: true,
      step: [true, false, false],
      frm: {
        user_info_seq: 0,
        id: '',
        pw: '',
        name: '',
        phone: '',
        parent_phone: '',
        school_name: '',
        user_type: 'T',
        use_yn: 'Y',
        file_seq: 0,
        birthday: '',
        join_dt: '',
        stat: '',
        auth_grp: '',
        memo: '',
        birthday_yyyy: '',
        birthday_mm: '',
        birthday_dd: ''
      },
      fileHeaders: {
        Authorization: '',
        Seq: 0,
        Table: 'USER'
      },
      yearCount: 0,
      startYear: 1965 - 1,
      imageUrl: '',
      parentSeqData: [],
      rules: {
        id: [
          { required: true, message: '사용자 아이디를 입력하십시오.', trigger: 'blur' },
          { min: 4, max: 15, message: '최소 4자 이상 최대 15자까지 입력하십시오.' },
          { type: 'string', pattern: /^[a-zA-Z0-9]/, message: '영어와 숫자만 가능합니다.' },
          { validator: checkUserId }
        ],
        name: [
          { required: true, message: '사용자 이름을 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 20, message: '최소 2자 이상 최대 20자까지 입력하십시오.' }
        ],
        phone: [
          { required: true, message: '전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        parent_phone: [
          { required: false, message: '보호자 전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^(?:\+?\d{0,3}[)|-]?\d{0,3}-?)\d{3,4}-?\d{4}$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        birthday_yyyy: [
          { required: true, message: '생년월일(년도)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_mm: [
          { required: true, message: '생년월일(월)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_dd: [
          { required: true, message: '생년월일(일)을 입력하십시오.', trigger: 'change' }
        ],
        school_name: [
          { min: 2, max: 20, message: '최소 2자 이상 최대 20자까지 입력하십시오.' }
        ]
      }
    }
  },
  created () {
  },
  computed: {
    userId: {
      get: function () {
        if (this.frm.user_type === 'S') {
          const id = 'K' + this.getOnlyNumber(this.frm.phone)
          this.setUserId(id)
          return id
        }
        return ''
      },
      set: function (value) {
        this.frm.id = value
      }
    },
    getDays: function () {
      return this.frm.birthday_mm !== '' ? this.getMonthLastDay(this.frm.birthday_yyyy + this.frm.birthday_mm) : 31
    },
    userTypeName: function () {
      let result = ''
      switch (this.frm.user_type) {
        case 'S':
          result = '학생'
          break
        case 'T':
          result = '선생님'
          break
        case 'A':
          result = '관리자'
          break
      }
      return result
    },
    userPassword: function () {
      if (this.frm.phone.length > 4) {
        return this.frm.phone.substr(this.frm.phone.length - 4)
      }
      return ''
    }
  },
  mounted () {
    this.fileHeaders.Authorization = this.$store.getters.access_token
    const today = new Date()
    this.yearCount = (this.startYear - today.getFullYear()) * -1
    // this.frm.birth_yyyy = parseInt(this.yearCount / 2, 10) + this.startYear
    // this.frm.birth_mm = today.getMonth() + 1
    // this.frm.birth_dd = today.getDate()
  },
  methods: {
    submitForm: function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.frm.birthday = this.frm.birthday_yyyy + this.frm.birthday_mm + this.frm.birthday_dd
          this.frm.phone = this.getOnlyNumber(this.frm.phone)
          this.frm.parent_phone = this.getOnlyNumber(this.frm.parent_phone)
          common.axios.post('/user/storage', this.frm)
            .then(response => {
              if (response.data.status === 1) {
                this.$message('등록하였습니다.')
                setTimeout(() => {
                  this.$router.push({name: 'M990201', params: {isSearch: true}})
                }, 1000)
              } else {
                this.$message.error(response.data.message)
              }
            })
            .catch(error => {
              if (error.response.data.errors) {
                error.response.data.errors.map(msg => {
                  this.$message.error(msg)
                })
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    resetForm: function (formName) {
      this.$refs[formName].resetFields()
      const resetFields = ['id', 'pw', 'name', 'phone', 'parent_phone', 'birthday', 'birthday_yyyy', 'birthday_mm', 'birthday_dd']
      resetFields.forEach(field => {
        this.frm[field] = ''
      })
      this.stepHandler(0)
    },
    handleAvatarSuccess (res, file) {
      if (res.status === 1 && res.file_seq !== undefined) {
        this.frm.file_seq = res.file_seq
        this.imageUrl = URL.createObjectURL(file.raw)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('사진은 jpg, png 파일만 업로드 가능합니다.')
      }
      if (!isLt2M) {
        this.$message.error('최대 2MB까지 가능합니다.')
      }
      return isJPG && isLt2M
    },
    getDateValue (value) {
      return (value < 10 ? '0' : '') + value
    },
    stepHandler (value) {
      this.step = [false, false, false]
      this.step[value] = true
    },
    stepFirst () {
      this.resetForm('frm')
      this.imageUrl = ''
      this.frm.file_seq = 0
      this.$nextTick(() => {
        this.stepHandler(0)
      })
    },
    validationForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.stepHandler(2)
          // common.axios.post('/user/check', {id: this.frm.id})
          //   .then(response => {
          //     if (response.data.status === 1) {
          //       this.stepHandler(2)
          //     } else {
          //       this.$message.error(response.data.message)
          //     }
          //   })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    phoneKeyUp () {
      if (this.frm.user_type === 'S') {
        this.frm.id = 'K' + this.getOnlyNumber(this.frm.phone)
      }
    },
    setUserId (value) {
      this.frm.id = value
    },
    autoHypenPhone (elem) {
      const value = this.getOnlyNumber(this.frm[elem])
      let tmp = ''
      if (value.length < 4) {
        tmp = value
      } else if (value.length < 7) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3)
      } else if (value.length < 11) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 3)
        tmp += '-'
        tmp += value.substr(6)
      } else {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 4)
        tmp += '-'
        tmp += value.substr(7)
      }
      this.frm[elem] = tmp
    },
    stepClassName (value) {
      return 'accordion-item' + (!this.step[value] ? ' deactive' : '')
    }
  },
  watch: {
    isUse: function (value) {
      this.frm.use_yn = value ? 'Y' : 'N'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .accordion-item-body .el-form-item {
    width: 550px;
    margin-left: 23%;
  }
  .accordion-item-body .el-form-item .el-form-item {
    width: 100%;
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M990202.vue